import React from 'react';
import { Cell } from 'react-table';
import _round from 'lodash/round';

import { formatNumberCompact } from '@trqk/utils';

import { gapBarHeight, gapBarMaxWidth, rowHeight } from '../../constants';

interface DetectionsCellProps {
    cell: Cell<TrqkGapChannel, GapChannelDetectionsCellValue>;
}

/**
 * Displays the number of detections that will be added if the current channel is included in the
 * Gap Analysis report. This number changes based on the state of the ConfirmWorks table for a
 * channel. If a user has included at least one work for a channel, the DetectionsCell shows the
 * sum of detections for the included works only. Otherwise, it shows the total detections in
 * the channel (for all works, regardless of whether they are included).
 */
export const DetectionsCell = ({ cell }: DetectionsCellProps): JSX.Element => {
    const {
        value: { detectionsCount, gapDenominator },
    } = cell;

    const gapBarWidthRaw = _round(
        (detectionsCount / gapDenominator) * gapBarMaxWidth,
    );
    const minGapBarWidth = Math.max(gapBarWidthRaw, 1);
    const gapBarWidth = detectionsCount > 0 ? minGapBarWidth : 0;

    return (
        <div
            className="flex items-center justify-between pl-2 ml-2 border-l border-tertiary-100"
            style={{ height: rowHeight }}
        >
            <div className="flex items-center">
                {formatNumberCompact(detectionsCount)}
            </div>
            <div className="flex justify-end" style={{ width: gapBarMaxWidth }}>
                <div
                    className="bg-secondary-500"
                    style={{ width: gapBarWidth, height: gapBarHeight }}
                />
            </div>
        </div>
    );
};
